import { render } from "./designHbox.vue?vue&type=template&id=b29faf60"
import script from "./designHbox.vue?vue&type=script&lang=js"
export * from "./designHbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__